import React, { useState } from 'react';
import { QuickLinkConfig } from './QuickLinkConfig';
import { Box, Card, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { FirmManufactureModal } from '../../Common/FirmManufactureModal';


const QuickLinks = ({
  allowedKeys,
  firmOnboarded = true,
  manufacturerSelected = null,
}) => {

  const quickLinkMap = QuickLinkConfig.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
  }, {});
  const navigate = useNavigate();
  const { selectedSupplierData } = useSelector((state) => state.entityReducer);
  const [firmModal, setFirmModal] = useState(false);
  const [manufacturerModal, setManufacturerModal] = useState(false);

  const handleQuickLinkClick = (path) => {
    if (selectedSupplierData?.nudge) {
      toast.warning(selectedSupplierData.nudge);
      return;
    }

    if (!firmOnboarded) {
      setFirmModal(true);
      return;
    }

    if (firmOnboarded && !manufacturerSelected) {
      setManufacturerModal(true);
      return;
    }

    navigate(path);
  };
  return (
    <>
      <Card
        sx={{
          p: 2,
          borderRadius: 2,
          boxShadow: "none",
          width: "100%",
          zIndex: 2,
        }}>
        <Typography variant="h2" mb={1}>
          Quick Links
        </Typography>
        <Grid container spacing={{ xs: 1, md: 2 }}>
          {allowedKeys?.quick_link_config?.map((item) => {
            const config = quickLinkMap[item.key];
            if (!config) return null;
            return (
              <Grid item xs={4} key={item.key}>
                <Box
                  sx={{
                    textAlign: "center",
                    p: 1,
                    borderRadius: 3,
                    cursor: "pointer",
                    width: "100%",
                  }}
                  onClick={() => handleQuickLinkClick(config.path)}>
                  <IconButton>{config.icon}</IconButton>
                  <Typography
                    sx={{
                      color: "#666666",
                      fontWeight: 600,
                      fontSize: "13px",
                      lineHeight: "20px",
                    }}>
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Card>
      <FirmManufactureModal
        firmModal={firmModal}
        setFirmModal={setFirmModal}
        manufacturerModal={manufacturerModal}
        setManufacturerModal={setManufacturerModal}
      />
    </>
  );
};

export default QuickLinks;
